module.exports = __webpack_public_path__ + "img/icon-bonus-ticket.7c425bbd.svg";